import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";

const CeoLeversPanel = ({ rows = [] }) => {
  if (!rows.length) {
    return null;
  }

  return (
    <section
      className="rounded-3xl border border-white/10 glass p-6"
      data-testid="pilotage-objectives-ceo-levers"
      aria-labelledby="pilotage-objectives-ceo-levers-title"
    >
      <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
        Leviers actionnables
      </p>
      <h2 id="pilotage-objectives-ceo-levers-title" className="mt-2 text-xl font-heading font-semibold text-white">
        Priorites
      </h2>

      <div className="mt-5 space-y-3">
        {rows.slice(0, 3).map((row) => (
          <article
            key={row.id}
            className="flex flex-col gap-3 rounded-2xl border border-white/10 bg-white/[0.03] p-4 sm:flex-row sm:items-center sm:justify-between"
            data-testid={`pilotage-objectives-ceo-lever-${row.id}`}
          >
            <div>
              <p className="text-sm font-semibold text-white">{row.label}</p>
              <p className="mt-1 text-sm text-slate-300">{row.valueLabel}</p>
            </div>
            <Button asChild className="btn-primary" aria-label={row.ctaLabel}>
              <Link to={row.to}>{row.ctaLabel}</Link>
            </Button>
          </article>
        ))}
      </div>
    </section>
  );
};

export default CeoLeversPanel;
